import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';
import { BsTree, BsPersonCircle } from 'react-icons/bs';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const user = await authAPI.login({ email, password });
      login(user);
      navigate('/');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split">
      <div className="login-sidebar">
        <h1><BsTree className="me-2" />GreenIQ</h1>
        <p>{t('hero_subtitle')}</p>
      </div>
      <div className="login-content">
        <div className="login-card">
          <h2>{t('login')}</h2>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div>
              <label className="form-label">{t('email')}</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="form-label">{t('password')}</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Logging in...' : t('login_button')}
            </button>
          </form>
          <button
            className="btn btn-outline-secondary w-100 mt-3"
            onClick={() => {
              login({ id: 'guest', name: 'Guest', email: 'guest@greeniq.com' });
              setTimeout(() => navigate('/'), 100);
            }}
          >
            <BsPersonCircle className="me-2" />Continue as Guest
          </button>
          <Link to="/register" className="d-block mt-3">{t('new_user')}</Link>
        </div>
      </div>
    </div>
  );
};
